var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("system.group.groupName"),
                              prop: "type",
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: { options: _vm.groupTypes },
                              model: {
                                value: _vm.queryCondition.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "type", $$v)
                                },
                                expression: "queryCondition.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sys.userList.userName"),
                              prop: "userName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.userName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "userName", $$v)
                                },
                                expression: "queryCondition.userName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.restQueryForm("queryCondition")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.reset")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "toolsBox" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.addCategory },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onDel } },
                  [_vm._v(_vm._s(_vm.$t("common.del")))]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                ref: "tableList",
                staticClass: "table",
                attrs: {
                  sortable: "",
                  data: _vm.tableData,
                  border: "",
                  "row-key": "tmGroupId",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    fixed: "",
                    "min-width": "50",
                    "reserve-selection": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    prop: "type",
                    label: _vm.$t("system.group.groupName"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    prop: "categoryCode",
                    label: _vm.$t("system.group.category"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    prop: "userName",
                    label: "用户名",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    prop: "hgsApproval",
                    label: "是否需HGS审批",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    prop: "supUserName",
                    label: "供应商用户",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showDetailDialog(scope.row)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.queryCondition.pageNum,
                    "page-sizes": _vm.pageSizeList,
                    "page-size": _vm.queryCondition.pageSize,
                    layout: _vm.pageLayout,
                    total: _vm.totalCount,
                  },
                  on: {
                    "size-change": _vm.pageSizeChange,
                    "current-change": _vm.pageNumberChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("nav.categoryGroupAdd"),
            visible: _vm.categoryDetailDialog,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.categoryDetailDialog = $event
            },
            close: _vm.categoryDetailDialogClose,
          },
        },
        [
          _vm.categoryDetailDialog
            ? _c(
                "el-form",
                {
                  ref: "categoryDetailForm",
                  staticClass: "categoryDetailForm",
                  attrs: {
                    model: _vm.categoryDetailForm,
                    rules: _vm.categoryDetailFormRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "GroupCode", prop: "type" } },
                            [
                              _c("ic-select", {
                                attrs: {
                                  clearable: "",
                                  options: _vm.groupTypes,
                                  disabled: _vm.isDisabled,
                                },
                                on: { change: _vm.typeChange },
                                model: {
                                  value: _vm.categoryDetailForm.type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.categoryDetailForm,
                                      "type",
                                      $$v
                                    )
                                  },
                                  expression: "categoryDetailForm.type",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.group.category"),
                                prop: "tmCategoryId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.categoryDetailForm.tmCategoryId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.categoryDetailForm,
                                        "tmCategoryId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "categoryDetailForm.tmCategoryId",
                                  },
                                },
                                _vm._l(_vm.categoryList, function (category) {
                                  return _c("el-option", {
                                    key: category.tmCategoryId,
                                    attrs: {
                                      value: category.tmCategoryId,
                                      label: category.name,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: _vm.$t("sys.userList.userName"),
                                prop: "userNames",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { readonly: "" },
                                  model: {
                                    value: _vm.categoryDetailForm.userNames,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.categoryDetailForm,
                                        "userNames",
                                        $$v
                                      )
                                    },
                                    expression: "categoryDetailForm.userNames",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.searchUser },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.categoryDetailForm.type === "CQS"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "是否需HGS审批",
                                    prop: "hgsApproval",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.categoryDetailForm.hgsApproval,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.categoryDetailForm,
                                            "hgsApproval",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "categoryDetailForm.hgsApproval",
                                      },
                                    },
                                    _vm._l(
                                      _vm.hgsApprovalLists,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.categoryDetailForm.type === "CQS"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "供应商用户",
                                    prop: "supUserName",
                                    "label-width": "120px",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { readonly: "" },
                                      model: {
                                        value:
                                          _vm.categoryDetailForm.supUserName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.categoryDetailForm,
                                            "supUserName",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression:
                                          "categoryDetailForm.supUserName",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          slot: "append",
                                          icon: "el-icon-search",
                                        },
                                        on: { click: _vm.searchSupplier },
                                        slot: "append",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
              _vm.isAdd
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveAdd } },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveEdit } },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showUserDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [
          _vm.DestroyUserDialog == true
            ? _c("PickupUser", {
                attrs: {
                  multi: true,
                  SelectedDefault: true,
                  emplFlag: "MCD",
                  SelectedDefaultId: _vm.categoryDetailForm.leaders,
                },
                on: { input: _vm.selectUser },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSupplierDialog = $event
            },
          },
        },
        [
          _c("PickupSupplier", {
            ref: "PickupSupplier",
            attrs: { supplierIds: this.supplierIds },
            on: { closeSelSupplier: _vm.closeSelSupplier },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }